import React, { Component } from 'react';
import { Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import Logo from 'containers/Logo';
import { logout, agreeTerms } from 'actions/user';

class TermsOfUse extends Component {
  onAgree = () => {
    this.props.agreeTerms('yes');
  };

  onDisagree = () => {
    this.props.logout(() => {});
    this.props.history.push('/home');
  };

  render() {
    return (
      <div style={{ width: 800, margin: '0 auto', paddingTop: 15 }}>
        <div className="text-center">
          <Logo />
          <h2>OnGo&trade; Certification Database</h2>
          <h2>Terms of Use</h2>
        </div>
        <div className="text-justify">
          <p>
            <i>Updated: March 26, 2018</i>
          </p>
          <p>
            These Terms of Use (“Terms”) govern your company’s (hereinafter
            “You” or “Your”) use and access of the OnGo&trade; Certification
            Database (“Database”), which is administered by CTIA Certification
            LLC (“CC LLC”). By accepting these Terms of Use, You acknowledge and
            agree that Your access and use of the Database is subject to your
            compliance with the terms provided below.
          </p>
          <h3>License Grant; Reservation of Rights</h3>
          <p>
            Subject to Your compliance with these Terms and payment of any
            applicable fees, CC LLC hereby grants You a limited, non-exclusive,
            non-assignable, non-transferable, non-sub-licensable, and revocable
            license to access and use the Database solely as necessary to
            participate in the OnGo&trade; Certification Program. You
            acknowledge and agree that the Database, its content, and the
            features, functionality and other aspects thereof, are owned or
            licensed by CC LLC and are protected under both United States and
            foreign laws. Except as explicitly stated in these Terms, CC LLC and
            its licensors reserve all rights in and to the Database and the
            OnGo&trade; Certification Program.
          </p>
          <h3>User Acknowledgments</h3>
          <ul>
            <li>
              You acknowledge that CC LLC makes no representations, warranties,
              or covenants related to Your compliance with any applicable
              technical or operational criteria as set forth in an applicable
              CBRS Alliance Test Plan.
            </li>
            <li>
              You acknowledge that CC LLC retains the right, in its sole and
              reasonable discretion, to suspend Your access to the Database if
              You do not comply with these Terms or as reasonably necessary to
              investigate or stop illegal, fraudulent, or suspicious activities,
              provided that CC LLC gives You notice of any such suspension or
              deactivation.
            </li>
            <li>
              You acknowledge that CC LLC may share any information or documents
              that You provide to the Database with CC LLC’s third party service
              providers, agents, or contractors as necessary to operate the
              Database; to administer the OnGo&trade; Certification Program; and
              may use such information or documents as necessary to perform
              internal network diagnostic services.
            </li>
            <li>
              You acknowledge that You own, or have all necessary legal rights
              to the information or documents that You provide to the Database;
              have sole responsibility for the accuracy, quality, integrity, and
              reliability of Your information and documents, and for obtaining
              any necessary rights or licenses, including all intellectual
              property rights, required for the disclosure of such information.
            </li>
            <li>
              You are responsible for evaluating the accuracy, completeness, and
              usefulness of all opinions, advice, services, other information,
              and the quality of all documents provided through the Database.
              Descriptions of or references to products, services, or
              publications within the Database do not imply CC LLC's endorsement
              of that product, service, or publication.
            </li>
            <li>
              You acknowledge that information or documents that You provide to
              the Database may be retained by or on behalf of CC LLC for
              administrative and auditing purposes.
            </li>
            <li>
              You acknowledge that third parties who provide information and
              documents to the Database for purposes of participating in the
              OnGo&trade; Certification Program may have ownership interests in
              some or all of the materials and data that they provide to the
              Database, and that all rights, interests, and permissions that You
              are granted through these Terms may be subject to such third party
              interests.
            </li>
            <li>
              You acknowledge and agree that the certification testing services
              will be performed by authorized test labs and that CC LLC has no
              responsibility for the accuracy or completeness of the
              certification testing services or the test results.
            </li>
            <li>
              You acknowledge and agree that the CBRS Alliance is an intended
              third party beneficiary of these Terms and is entitled to enforce
              the suspension rights described in the User Acknowledgement
              section, as well as any rights and remedies with respect to its
              intellectual property rights.
            </li>
            <li>
              You acknowledge and agree that CC LLC is not the publisher of
              information or documents posted in the Database by authorized
              users, but agree that CC LLC has the right to disclose any
              information necessary to (1) satisfy any law, regulation, or other
              governmental request; (2) operate the Database properly; (3) to
              protect itself or CBRS Alliance.
            </li>
            <li>
              You acknowledge and agree that CC LLC reserves the right to refuse
              to post or to remove any information or materials, in whole or in
              part, that, in its sole discretion, are unacceptable or
              undesirable.
            </li>
          </ul>
          <h3>Restricted Rights of Use of the Services</h3>
          <p>
            You are allowed to access and use the Database only as described
            herein and only as necessary to participate in the OnGo&trade;
            Certification Program. If any third party confidential or
            proprietary data is inadvertently made available to You through the
            Database, You must immediately notify CC LLC, whereupon the
            necessary corrections will be made at the sole discretion of CC LLC.
            You will not violate any applicable law, regulation, contract,
            intellectual property, or other third-party right, or commit a tort,
            and You are solely responsible for Your conduct while accessing or
            using the Database. Without limiting the foregoing, You will not:
          </p>
          <ul>
            <li>
              use, nor allow others to use, any data extracted from the Database
              in any way that may be considered injurious, harmful, or
              detrimental to CC LLC or CBRS Alliance;
            </li>
            <li>
              adapt, translate, reverse engineer, decompile, disassemble, or
              otherwise attempt to discover the source code of the Database or
              related intellectual property rights of CC LLC;
            </li>
            <li>
              assign, sublicense, pledge, lease, rent, sell, or distribute
              commercially the Services or any materials, data, or information
              that You receive through Your access to the Database;
            </li>
            <li>
              modify, make, sell, or create derivative works based upon the
              Database or the Services;
            </li>
            <li>
              attempt to access portion of the Database that You have not been
              authorized to access;
            </li>
            <li>
              attempt to intentionally disable, slow, prevent operation of, or
              otherwise interfere with or change any normal or usual operation
              of the Database;
            </li>
            <li>
              duplicate any portion of the Database, Services, or the
              OnGo&trade; Certification Program, including the duplication of
              certification test plans, processes, procedures, policies, or CBRS
              Alliance End User agreements;
            </li>
            <li>
              access the Services in order to build a competitive product or
              service or for benchmarking or other competitive purposes;
            </li>
            <li>
              use the Services to send or store material containing software
              viruses, worms, trojan horses, cancelbot, or other harmful
              computer code, files, scripts, agents or programs; or other such
              devices, that will cause the Database, and website owned by CTIA,
              CTIA's computer network, or any component thereof to be erased or
              become inoperable or incapable of processing or affect operations
              of other systems;
            </li>
            <li>attempt to circumvent any content-filtering techniques; or</li>
            <li>
              develop or use any third-party applications that interact with the
              Database without CC LLC’s prior written consent, including any
              scripts designed to scrape or extract data from the Services, post
              or transmit any unlawful, threatening, abusive, libelous,
              defamatory, obscene, pornographic, profane or otherwise
              objectionable information of any kind, including without
              limitation any transmission constituting or encouraging conduct
              that would constitute a criminal offense, give rise to civil
              liability, or otherwise violate any local, state, national or
              international law, including without limitation the United States
              export control laws and regulations and federal and state
              antitrust laws; laws governing the use of trademarks, copyrighted
              materials, patents, defamation and privacy laws; and laws
              governing the right of publicity
            </li>
            <li>
              post, publish, transmit, reproduce, distribute, or in any way
              exploit any information or other material obtained through the
              Database for commercial purposes other than for the OnGo&trade;
              Certification Program or as expressly permitted by the provider of
              such information or other material; or
            </li>
            <li>
              upload, post, publish, transmit, reproduce, or distribute in any
              way, information or other material obtained through the Database
              that is protected by copyright, trademark, patent laws or other
              proprietary right, or derivative works with respect thereto,
              without obtaining permission of the owner or holder of the
              respective copyright, trademark, patent or other proprietary
              right.
            </li>
          </ul>
          <p>
            The Database is provided on an "AS IS" and "AS AVAILABLE" basis
            without warranties of any kind, either expressed or implied,
            including but not limited to warranties of title, non-infringement,
            or implied warranties of merchantability or fitness for a particular
            purpose. CC LLC does not warrant that: (1) the Database will be
            uninterrupted or error free; (2) errors, misstatements or
            programming defects in the Database will be corrected; or (3) any
            access to the Database or information or documents accessible
            through the Database is free of viruses, worms, trojan horses or
            other harmful elements. Under no circumstances shall CC LLC be
            liable for any direct, indirect, incidental, special, punitive or
            consequential damages that result in any way from authorized users'
            use of or inability to use the Database or reliance on or use of
            information, documents, or services provided through the Database or
            that result from mistakes, omissions, interruptions, deletion of
            files, errors, defects, delays in operation, or transmission, or any
            failure of performance.
          </p>
        </div>
        <div>
          <Col xs={6}>
            <div className="text-center" style={{ padding: '25px 0' }}>
              <Button
                bsStyle="success"
                bsSize="large"
                onClick={this.onAgree}
                className="button-box-shadow"
              >
                I AGREE
              </Button>
            </div>
          </Col>
          <Col xs={6}>
            <div className="text-center" style={{ padding: '25px 0' }}>
              <Button
                bsStyle="danger"
                bsSize="large"
                onClick={this.onDisagree}
                className="button-box-shadow"
              >
                I DISAGREE
              </Button>
            </div>
          </Col>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  { logout, agreeTerms }
)(TermsOfUse);



// WEBPACK FOOTER //
// ./src/containers/TermsOfUse.js